import type { DeepPartial } from '@apollo/client/utilities';
import { ManagerInformation } from '../ManagerInformation';
import type { EmployeeAlertListItemReasonManager } from '../types';

type Reason = {
  primaryManager?: DeepPartial<EmployeeAlertListItemReasonManager>;
  dottedLineManager?: DeepPartial<EmployeeAlertListItemReasonManager>;
};

export const DetailDescriptionEmployeeAlertInactiveManager = ({ reason }: { reason: Reason }) => (
  <div>
    {reason.primaryManager && <ManagerInformation manager={reason.primaryManager} />}
    {reason.dottedLineManager && <ManagerInformation manager={reason.dottedLineManager} />}
  </div>
);
